module.exports = __webpack_public_path__ + "img/Group1474.5857f99f.svg";